import React, { Component } from 'react';
import './Nav.css';

import { Link } from 'react-router-dom';

class Nav extends Component {
	constructor(props) {
		super(props);
		this.state = { isOpened: true };

		this.toggelState = this.toggelState.bind(this);
		this.toggelStateLink = this.toggelStateLink.bind(this);
	}

	componentDidMount() {
		let mw = window.matchMedia('(max-width: 580px)').matches;
		if (mw) {	this.setState({ isOpened: false });	}
	}

	toggelState() {
		this.setState({ isOpened: !this.state.isOpened });
	}

	toggelStateLink() {
		let mw = window.matchMedia('(max-width: 580px)').matches;
		if (mw) {	this.setState({ isOpened: false }); }
	}

  render() {
		let dropdaunText;
		if (this.state.isOpened) {
			dropdaunText =	<ul> 
												<li><Link onClick={this.toggelStateLink} to='/'>Головна</Link></li>
												<li><Link onClick={this.toggelStateLink} to='/prise'>Прайс</Link></li>
												<li><Link onClick={this.toggelStateLink} to='/about'>Про нас</Link></li>
												<li><Link onClick={this.toggelStateLink} to='/contact'>Контакти</Link></li>
											</ul>
		}
    return (
			<nav>
				<Link onClick={this.toggelState} to="#">Menu</Link>
				{dropdaunText}
			</nav>
    );
  } 
}

export default Nav;


// WEBPACK FOOTER //
// ./src/Components/Nav.jsx